import React from 'react'
import { Link, useHistory } from "react-router-dom";


export default function Footer() {
  return (
    <footer
      className="text-center text-surface/75 bg-black  text-white/75 lg:text-left">
      <div
        className="flex items-center justify-center border-b-2 border-neutral-200 p-6 border-white/10 lg:justify-between">
        <div className="me-12 hidden lg:block">
          <span>Hubungi kita dengan sosial media berikut:</span>
        </div>
        <div className="flex justify-center">
          <a href="https://maps.app.goo.gl/ZtP2pquEvngesutYA" rel="noopener noreferrer" target="_blank" className="me-6 [&>svg]:h-4 [&>svg]:w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 488 512">
              <path
                d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
            </svg>
          </a>
          <a href="https://www.instagram.com/bbyshinn_towing/" rel="noopener noreferrer" target="_blank" className="me-6 [&>svg]:h-4 [&>svg]:w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 448 512">
              <path
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
            </svg>
          </a>
          <a href="https://www.facebook.com/profile.php?id=100082855175142" rel="noopener noreferrer" target="_blank" className="me-6 [&>svg]:h-4 [&>svg]:w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 320 512">
              <path
                d="M279.14 288l14.22-92.66h-88.91V134.42c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S257.91 0 225.36 0c-73.22 0-121.14 44.38-121.14 124.72v70.62H22.89V288h81.33v224h100.2V288z" />
            </svg>
          </a>
        </div>
      </div>
    
      <div className="mx-6 py-10 text-center md:text-left">
        <div className="flex flex-col md:flex-row justify-center items-center md:justify-between gap-10 md:gap-0">
          <div className="flex flex-col gap-4 items-center justify-center w-1/3">
            <h6 className="flex justify-center font-semibold uppercase md:justify-start">
              Tautan
            </h6>
            <p><Link to="/">Home</Link></p>
            <p><a href="#about">About</a></p>
            <p><a href="#service">Service</a></p>
            <p><Link to="/gallery">Gallery</Link></p>
          </div>
          <div className="flex flex-col gap-4 justify-center items-center w-1/3">
            <h6 className="font-semibold uppercase md:justify-start">Contact</h6>
            <div className="flex flex-col gap-4 justify-center">
              <p className="w-[350px] md:w-[500px] flex items-center justify-center md:justify-start">
                <span className="me-3 [&>svg]:h-5 [&>svg]:w-5">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                    <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                  </svg>
                </span>
                Office Perum KD.Asri No.A 18 Tegalsari, Kayen, Kec. Bandarkedungmulyo, Kabupaten Jombang, Jawa Timur 61462
              </p>
              <p className="flex items-center justify-center md:justify-start">
                <span className="me-3 [&>svg]:h-5 [&>svg]:w-5">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                </span>
                <a href="mailto:isaendika1@gmail.com" className="email-link" rel="noopener noreferrer">isaendika1@gmail.com</a>
              </p>
              <p className="flex items-center justify-center md:justify-start">
                <span className="me-3 [&>svg]:h-5 [&>svg]:w-5">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clipRule="evenodd" />
                  </svg>
                </span>
                +6282288349889
              </p>
            </div>
          </div>
          <div>
            <img className="w-64 rounded-full" src="./image/BBYSHIN_TOWING.webp" alt="BBYSHIN Towing Office" />
          </div>
        </div>
      </div>
    
      <div className="bg-black/5 p-6 text-center">
        <span>© 2024 Made by:</span>
        <a className="font-semibold" href="https://portfoliolegoin.vercel.app"
          >Kenqer</a
        >
      </div>
    </footer>
  )
}
